<template>
  <div class="header">
    <h1 v-if="!isLink">
      {{ title }}
    </h1>
    <h1 v-if="isLink">
      <router-link :to="{name: link, query: { clientId: $route.query.clientId, companyId: $route.query.companyId, userEmail: $route.query.userEmail }}">
        <font-awesome-icon
          :icon="['far', 'chevron-left']"
          size="lg"
        />  {{ title }}
      </router-link>
    </h1>
  </div>
</template>
<script>

export default {
  name: 'Header',
  props: {
    title: String,
    isLink: Boolean,
    link: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  h1 {
    color: #000;
    a {
      text-decoration: none;
      color: #000;
      cursor: pointer;
      .fa-lg {
        vertical-align: -0.2rem;
        margin-right: 7px;
      }
    }
  }
}

</style>
